import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SEO from "@/components/site/SEO";
import { organizationSchema, breadcrumbSchema } from "@/data/site";

export default function About() {
  return (
    <div className="bg-white text-brand-black">
      <SEO
        title="About"
        description="LotWise Home was built around a simple belief: property listings should not depend on whoever has time. A better standard for real estate listings across southeastern Ontario."
        path="/about"
        schema={[organizationSchema, breadcrumbSchema([{ name: "Home", path: "/" }, { name: "About", path: "/about" }])]}
      />
      <section className="bg-brand-black text-white">
        <div className="mx-auto max-w-[1360px] px-5 md:px-10 py-24 md:py-32">
          <div className="eyebrow text-white/60">About</div>
          <h1 className="mt-4 text-[40px] md:text-7xl font-bold tracking-[-0.02em] leading-[1.0] max-w-4xl">
            A better <span className="text-brand-gradient">standard</span> for real estate listings.
          </h1>
        </div>
      </section>

      <section className="bg-white">
        <div className="mx-auto max-w-[900px] px-5 md:px-10 py-20 md:py-28 space-y-6 text-[16px] md:text-[17px] leading-relaxed text-brand-gray">
          <p>
            LotWise Home was built around a simple belief: property listings should not depend on
            whoever has time.
          </p>
          <p>
            A listing is often the first proof of an agent's standard. Photos, details, room notes,
            web presentation, and seller-facing confidence all matter before the showing ever happens.
          </p>
          <p>
            LotWise Home gives agents, teams, and brokerages a more controlled way to prepare and
            present listings properly.
          </p>
          <p className="text-brand-black text-[19px] md:text-[22px] font-medium tracking-tight leading-snug">
            The goal is not to make listings look like something they are not. It is to make sure
            they look like something that has been handled.
          </p>
        </div>
      </section>

      <section className="bg-[#F7F7F5]">
        <div className="mx-auto max-w-[1360px] px-5 md:px-10 py-20 md:py-28 grid md:grid-cols-3 gap-4">
          {[
            { t: "Ownership", b: "The listing has one defined execution layer." },
            { t: "Consistency", b: "Every property follows a stronger capture and presentation standard." },
            { t: "Control", b: "Agents know what is captured, prepared, and delivered." },
          ].map((c) => (
            <div key={c.t} className="bg-white border border-brand-gray/25 p-6">
              <div className="eyebrow-accent">Principle</div>
              <h3 className="mt-3 text-xl font-bold tracking-tight">{c.t}</h3>
              <p className="mt-3 text-[14px] text-brand-gray leading-relaxed">{c.b}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-brand-black text-white">
        <div className="mx-auto max-w-[1360px] px-5 md:px-10 py-20 md:py-28 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <h3 className="text-2xl md:text-4xl font-bold tracking-tight max-w-2xl">Bring your next listing onto the standard.</h3>
          <Link to="/contact" className="inline-flex items-center gap-2 bg-white text-brand-black px-6 py-3.5 text-[13px] font-bold">
            Request Listing Support <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
